export const HeartCommentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M12,1C5.649,1,.5,5.253.5,10.5a8.738,8.738,0,0,0,3.4,6.741L1.5,23l6.372-3.641A13.608,13.608,0,0,0,12,20c6.351,0,11.5-4.253,11.5-9.5S18.351,1,12,1Z"
        fill="#00e6ca"
      />
      <path
        d="M12,5a14.371,14.371,0,0,1,11.5,5.265C23.346,5.127,18.256,1,12,1S.654,5.127.5,10.265A14.371,14.371,0,0,1,12,5Z"
        fill="#c4f0eb"
      />
      <path
        d="M12,1C5.649,1,.5,5.253.5,10.5a8.738,8.738,0,0,0,3.4,6.741L1.5,23l6.372-3.641A13.608,13.608,0,0,0,12,20c6.351,0,11.5-4.253,11.5-9.5S18.351,1,12,1Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12,15,7.861,10.682A2.447,2.447,0,0,1,7.4,7.855h0a2.449,2.449,0,0,1,3.922-.637L12,7.894l.676-.676a2.449,2.449,0,0,1,3.922.637h0a2.449,2.449,0,0,1-.458,2.827Z"
        fill="#00e6ca"
      />
      <path
        d="M16.6,7.855a2.449,2.449,0,0,0-3.922-.637L12,7.894l-.676-.676a2.443,2.443,0,0,0-4.1,2.342,6.493,6.493,0,0,0,9.611-.389A2.429,2.429,0,0,0,16.6,7.855Z"
        fill="#c4f0eb"
      />
      <path
        d="M12,15,7.861,10.682A2.447,2.447,0,0,1,7.4,7.855h0a2.449,2.449,0,0,1,3.922-.637L12,7.894l.676-.676a2.449,2.449,0,0,1,3.922.637h0a2.449,2.449,0,0,1-.458,2.827Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
